module finadai.app.customers.cancel_negotiation {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.customers.cancel_negotiation"
    function CustomerCancelNegotiationController(customer: ng.IHttpPromiseCallbackArg<ProxyRecord<models.proxy.Customer>>,
                                      creditInfo:  ng.IHttpPromiseCallbackArg<ProxyRecord<models.proxy.Credito>>,
                                      negotiation:  ng.IHttpPromiseCallbackArg<ProxyRecord<models.proxy.Negociacion>>,
                                      customersService: services.CustomersService, whoIAm: models.User, $rootScope, $scope, notify,
                                      confirm, $mdDialog: ng.material.IDialogService, $state: ng.ui.IStateService,
                                      negotiationsService: services.NegotiationsService, proxifier, $q: ng.IQService,
                                      authService: services.AuthService) {
        return;
        $scope.customer = customer.data.Data;
        $scope.credit = creditInfo.data.Data;
        $scope.negotiation = negotiation.data.Data;
        $scope.user = whoIAm;
        $scope.selectedReason = {id: null, name: ''};
        $scope.reasons = [
            {id: 1, name: 'El plazo es insuficiente/El monto es muy alto'},
            {id: 2, name: 'Desconfío de la información que me proporcionaron para realizar el (los) pago(s)'},
            {id: 3, name: 'Registraron este convenio sin mi completa aprobación'}
            ];
        $scope.hoy = new Date();
        $scope.refreshPage = () => {
            location.reload();
        }
        $scope.submitNegotiationCancel = () => {
            $scope.cancelNegotiation = true
            const promise = customersService.proxyCancelNegotiation({
                customer_number: whoIAm.customer_number,
                rfc: whoIAm.rfc,
                reason_id: $scope.selectedReason.id,
                user_id: whoIAm.id,
            });

            promise.then(response => {
                $scope.canceldNegotiationResponse = response.data.Data.Encabezado;
                $scope.cancelNegotiation = false;
                notify('Negociación Cancelada.');
                $state.go('app.customers.profile');
            }).catch(error => {
                $scope.cancelNegotiation = false;
                if( error.status != 422 ) {
                    notify('Tuvimos un problema, contáctanos via chat.', 'danger');
                }
            })
        }
    }
    export function run() {
        var cancel_negotiation = angular.module(NAME, [])
        cancel_negotiation.controller("CustomerCancelNegotiationController", CustomerCancelNegotiationController)
    }
}
finadai.app.customers.cancel_negotiation.run();